import { useContext, useEffect } from 'react'
import { Skeleton } from '@mui/material';
import DynamicForm, { useDynamicForm } from '../forms/DynamicFormNew';
import { ICustomerBasic, CUSTOMER_FORM_CONFIG } from '../../Models/Customer';
import { CustomerContext } from '../../contexts/CustomerContext';
import { NotificationContext } from '../../contexts/NotificationContext';
import { SIX_MASKED_DIGITS_REGEX } from '../../utils/constant';


const FormSkeleton = ({ rows }: { rows?: number }) => {
    rows = rows ? rows : 4
    return <div style={{
        width: '100%',
        display: 'flex',
        columnGap: '20px',
        flexWrap: 'wrap'
    }}>
        {Array(4 * 2).fill('_').map((_, i) => <Skeleton key={i + 'field_skeleton'} animation="wave" width='calc(50% - 20px)' height={100} />)}
    </div>
}


const CustomerBasicDetails = ({ loading, setIndex }: { loading: boolean, setIndex:Function }) => {

    const { customerConfig, setCustomerConfig } = useContext(CustomerContext)
    const { notify } = useContext(NotificationContext)

    const getConfig = () => CUSTOMER_FORM_CONFIG.map(field => ({...field, value: customerConfig[field.fieldName as keyof ICustomerBasic] }))

    const { registerForm, setField, setFormData, setFormConfig, formData} = useDynamicForm({
        formConfig: getConfig()
    })

    const handleSubmit = (formData: ICustomerBasic) => {
        console.log('handleSubmit', formData)
        setCustomerConfig(formData)
        notify('Saved basic details.')
        setIndex(1)
    }

    useEffect(() => {
        setFormData(customerConfig)
        setFormConfig((prev)=>{
            return prev.map(field=>{
                if( field.fieldName === 'mobileNumber' && SIX_MASKED_DIGITS_REGEX.test(customerConfig.mobileNumber) ){
                    field.validation = { required : true }
                }
                return field ;
            })
        })
    }, [loading])

    useEffect(() => {
        let showEmployee= formData.userType === 'employee' || formData.userType === 'F&F'
        setField('employeeCode', {isVisible:showEmployee , validation:{ required:showEmployee }})
    }, [formData.userType])

    return <>
        <div style={{ padding: '0 10px' }}>
            <div style={{ padding: '20px 0px' }}>
                {loading ?
                    <FormSkeleton /> :
                    <DynamicForm
                        onSubmit={handleSubmit}
                        submitText='Save & Next'
                        {...registerForm()}
                    />}
            </div>
        </div>
    </>
}

export default CustomerBasicDetails